const FormResources = {

    form_data:{
        scenario:                           '',
        fte_hours:                          0,
        budgeted_ftes:                      0,
        date:                               '',
        benefits:                           0,
        nonproductive:                      0,
        paid_break_minutes:                 0,
        updated_date:                       '',
        management_team:                    0,
        average_wage:                       0,
        total_salary:                       0,
        ld_case_number: 0,          
        ld_case_emp_proc: 0,            
        ld_case_minutes: 0,        
        ld_case_daily_minutes: 0,           
        ld_case_days_week: 0,           
        ld_case_annual_hours: 0,            
        ld_case_ftes: 0,            
        or_case_number: 0,          
        or_case_emp_proc: 0,            
        or_case_minutes: 0,         
        or_case_daily_minutes: 0,           
        or_case_days_week: 0,           
        or_case_annual_hours: 0,            
        or_case_ftes: 0,            
        discharge_number: 0,            
        discharge_emp_proc: 0,          
        discharge_minutes: 0,           
        discharge_daily_minutes: 0,         
        discharge_days_week: 0,         
        discharge_annual_hours: 0,          
        discharge_ftes: 0,                
        cath_lab_between_case_number: 0,            
        cath_lab_between_case_emp_proc: 0,          
        cath_lab_between_case_minutes: 0,           
        cath_lab_between_case_daily_minutes: 0,         
        cath_lab_between_case_days_week: 0,         
        cath_lab_between_case_annual_hours: 0,          
        cath_lab_between_case_ftes: 0,          
        triagle_between_case_number: 0,         
        triagle_between_case_emp_proc: 0,           
        triagle_between_case_minutes: 0,            
        triagle_between_case_daily_minutes: 0,          
        triagle_between_case_days_week: 0,          
        triagle_between_case_annual_hours: 0,           
        triagle_between_case_ftes: 0,           
        ed_between_case_number: 0,          
        ed_between_case_emp_proc: 0,            
        ed_between_case_minutes: 0,         
        ed_between_case_daily_minutes: 0,           
        ed_between_case_days_week: 0,           
        ed_between_case_annual_hours: 0,            
        ed_between_case_ftes: 0,            
        notes: '',
        min_discharge_birth:0,
        min_discharge_operating_room:0,
    },
    discharges_format:[
        {
            name: 'L&D Cases',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'ld_case_number',
                    ref:        'ld_case_number_input',
                    ref_alt:    'ld_case_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Emp/Proc:',
                    model_name: 'ld_case_emp_proc',
                    ref:        'ld_case_emp_proc',
                    ref_alt:    'ld_case_emp_proc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ld_case_minutes',
                    ref:        'ld_case_minutes',
                    ref_alt:    'ld_case_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ld_case_daily_minutes',
                    ref:        'ld_case_daily_minutes',
                    ref_alt:    'ld_case_daily_minutes_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ld_case_days_week',
                    ref:        'ld_case_days_week',
                    ref_alt:    'ld_case_days_week_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ld_case_annual_hours',
                    ref:        'ld_case_annual_hours',
                    ref_alt:    'ld_case_annual_hours_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ld_case_ftes',
                    ref:        'ld_case_ftes',
                    ref_alt:    'ld_case_ftes_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
            ]
        },
        {
            name: 'OR Cases',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'or_case_number',
                    ref:        'or_case_number',
                    ref_alt:    'or_case_number_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Emp/Proc:',
                    model_name: 'or_case_emp_proc',
                    ref:        'or_case_emp_proc',
                    ref_alt:    'or_case_emp_proc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'or_case_minutes',
                    ref:        'or_case_minutes',
                    ref_alt:    'or_case_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'or_case_daily_minutes',
                    ref:        'or_case_daily_minutes',
                    ref_alt:    'or_case_daily_minutes_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'or_case_days_week',
                    ref:        'or_case_days_week',
                    ref_alt:    'or_case_days_week_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'or_case_annual_hours',
                    ref:        'or_case_annual_hours',
                    ref_alt:    'or_case_annual_hours_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'or_case_ftes',
                    ref:        'or_case_ftes',
                    ref_alt:    'or_case_ftes_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
            ]
        },
        {
            name: 'Discharges',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'discharge_number',
                    ref:        'discharge_number',
                    ref_alt:    'discharge_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Emp/Proc:',
                    model_name: 'discharge_emp_proc',
                    ref:        'discharge_emp_proc',
                    ref_alt:    'discharge_emp_proc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'discharge_minutes',
                    ref:        'discharge_minutes',
                    ref_alt:    'discharge_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'discharge_daily_minutes',
                    ref:        'discharge_daily_minutes',
                    ref_alt:    'discharge_daily_minutes_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'discharge_days_week',
                    ref:        'discharge_days_week',
                    ref_alt:    'discharge_days_week_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'discharge_annual_hours',
                    ref:        'discharge_annual_hours',
                    ref_alt:    'discharge_annual_hours_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'discharge_ftes',
                    ref:        'discharge_ftes',
                    ref_alt:    'discharge_ftes_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$"
                },
            ]

        },
        {
            name: 'Cath Lab In Between Cases',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'cath_lab_between_case_number',
                    ref:        'cath_lab_between_case_number',
                    ref_alt:    'cath_lab_between_case_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Emp/Proc:',
                    model_name: 'cath_lab_between_case_emp_proc',
                    ref:        'cath_lab_between_case_emp_proc',
                    ref_alt:    'cath_lab_between_case_emp_proc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'cath_lab_between_case_minutes',
                    ref:        'cath_lab_between_case_minutes',
                    ref_alt:    'cath_lab_between_case_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'cath_lab_between_case_daily_minutes',
                    ref:        'cath_lab_between_case_daily_minutes',
                    ref_alt:    'cath_lab_between_case_daily_minutes_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'cath_lab_between_case_days_week',
                    ref:        'cath_lab_between_case_days_week',
                    ref_alt:    'cath_lab_between_case_days_week_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'cath_lab_between_case_annual_hours',
                    ref:        'cath_lab_between_case_annual_hours',
                    ref_alt:    'cath_lab_between_case_annual_hours_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'cath_lab_between_case_ftes',
                    ref:        'cath_lab_between_case_ftes',
                    ref_alt:    'cath_lab_between_case_ftes_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
            ]

        },
        {
            name: 'Triagle In Between Cases',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'triagle_between_case_number',
                    ref:        'triagle_between_case_number',
                    ref_alt:    'triagle_between_case_number_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Emp/Proc:',
                    model_name: 'triagle_between_case_emp_proc',
                    ref:        'triagle_between_case_emp_proc',
                    ref_alt:    'triagle_between_case_emp_proc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'triagle_between_case_minutes',
                    ref:        'triagle_between_case_minutes',
                    ref_alt:    'triagle_between_case_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'triagle_between_case_daily_minutes',
                    ref:        'triagle_between_case_daily_minutes',
                    ref_alt:    'triagle_between_case_daily_minutes_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'triagle_between_case_days_week',
                    ref:        'triagle_between_case_days_week',
                    ref_alt:    'triagle_between_case_days_week_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'triagle_between_case_annual_hours',
                    ref:        'triagle_between_case_annual_hours',
                    ref_alt:    'triagle_between_case_annual_hours_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'triagle_between_case_ftes',
                    ref:        'triagle_between_case_ftes',
                    ref_alt:    'triagle_between_case_ftes_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
            ]

        },
        {
            name: 'ED In Between Cases',
            fields: [
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Number:',
                    model_name: 'ed_between_case_number',
                    ref:        'ed_between_case_number_input',
                    ref_alt:    'ed_between_case_number_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Emp/Proc:',
                    model_name: 'ed_between_case_emp_proc',
                    ref:        'ed_between_case_emp_proc',
                    ref_alt:    'ed_between_case_emp_proc_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ed_between_case_minutes',
                    ref:        'ed_between_case_minutes',
                    ref_alt:    'ed_between_case_minutes_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ed_between_case_daily_minutes',
                    ref:        'ed_between_case_daily_minutes',
                    ref_alt:    'ed_between_case_daily_minutes_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
                {
                    css_class:  'col-md-6',
                    type:       'number',
                    maxlength:  '',
                    disabled:   false,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ed_between_case_days_week',
                    ref:        'ed_between_case_days_week',
                    ref_alt:    'ed_between_case_days_week_input_alt',
                    required:   false,
                    max_width:   '100%'
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ed_between_case_annual_hours',
                    ref:        'ed_between_case_annual_hours',
                    ref_alt:    'ed_between_case_annual_hours_input_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
                {
                    css_class:  'col-md-6',
                    type:       'text',
                    maxlength:  '',
                    disabled:   true,
                    step:       'any',
                    name:       'Cath Lab Case Total Minutes:',
                    model_name: 'ed_between_case_ftes',
                    ref:        'ed_between_case_ftes',
                    ref_alt:    'ed_between_case_ftes_alt',
                    required:   false,
                    max_width:   '100%',
                    pattern: "^\\d{1,3}(,\\d{3})*(\\.\\d+)?$",
                },
            ]

        }
    ],

    form_format: [
       
    ],

    form_format_duplication: [
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Name for the scenario to be duplicated',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
            max_width:   '100%'
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Do you want to duplicate the fixed data?',
            model_name: 'staffing_fixed_data',
            ref:        'staffing_fixed_data_input',
            ref_alt:    'staffing_fixed_data_input_alt',
            required:   false,
            max_width:   '100%'
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Do you want to duplicate the variable data?',
            model_name: 'variable_data',
            ref:        'variable_data_input',
            ref_alt:    'variable_data_input_alt',
            required:   false,
            max_width:   '100%'
        }
],

    form_data_duplication: {
        name: '',
        staffing_fixed_data: false,
        variable_data: false
    }

}

export default FormResources;